/**!
* ReactIntlFormat 0.1.2
* Copyright (c) Shotzoom Software LLC. All rights reserved.
* Licensed under the MIT license. See LICENSE file in the project root for details.
*/
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import invariant from 'invariant';
/**
 * Configures a new Formatter.
 * 
 * @param {function(intl: intlShape, props: object): any} apiSelector 
 * @param {object} options
 * @returns {Function}
 */

function configure(apiSelector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === undefined ? "Format" : _ref$displayName;

  invariant(typeof apiSelector === "function", "Expected apiSelector to be a function but received '%s'.", JSON.stringify(apiSelector));

  function Format(props, context) {
    return props.children(apiSelector(context.intl, props));
  }

  Format.displayName = displayName;
  Format.contextTypes = {
    intl: intlShape.isRequired
  };
  Format.propTypes = {
    children: PropTypes.func.isRequired
  };
  return Format;
}

var Format = configure(function (intl) {
  return intl;
});
export { configure, Format };